import React from "react";
import { connect } from "react-redux";
import { useForm, ErrorMessage } from "react-hook-form";
import withSizes from 'react-sizes';
import { Container, Row, Col } from "deltoid/core/Blocks/BootstrapContainers";
import { Card } from "deltoid/core/OneDashCards";
import { H, Caption } from "deltoid/core/Blocks/Typography";
import Form from "deltoid/core/Form";

import SignUpCMS from "../../features/prismic/SignUpCMS";
import { createUser } from '../../../shared/actions/auth';
import { 
    mobileNumberRegex
  } from '../../../shared/services/validations';

import LoginIllustration from "../../../assets/svgs/loginIllustration.svg";
import PayUIcon from "../../../assets/svgs/PayU-Icon.svg";
import { UserResponse } from '../../../shared/utils/response';

const MobileSet = (props) => {
  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (formData) => {
    const params = {
      can_create: true,
      mobile: formData.mobile,
    };
    try {
      const res = await createUser(props.dispatch, params);
      const user = UserResponse(res.data);
      const userDetails = {
        ...formData,
        useMobile: true,
        user: user,
      }
      props.history.push({
        pathname: '/account/mobile/otp',
        state: {
          ...props.location.state,
          ...userDetails,
        }
      });

    } catch (e) {
      console.log(e);
    }
  };


  return (
    <Container fluid className='vector-bg login-max-width-container'>
      <Row>
        {props.isMobile ?
            <Col md={12} className='p-0 d-flex justify-content-between grey-background login-illustration'>
              <span className='pt-4 px-4'><PayUIcon /></span>
              <LoginIllustration />
            </Col>
              :
            <Col md={6} className='p-0'>
              <SignUpCMS />
            </Col>
          }
        <Col md={5} className={props.isMobile && 'm-0 p-0'}>
          <div className={!props.isMobile && 'login-container mt-5 mx-4'}>
          <Card>
            <H level={5} variant="regular" className="co-heading worksansregular-font">
                Set Mobile Number
            </H>
            <Caption className='pt-3'>
                Please set a new mobile number for your PayU account
            </Caption>
            <form onSubmit={handleSubmit(onSubmit)} className='px-3 py-3'>
                <Row>
                  <Form.Group className="position-relative pt-4 mb-3">
                    <Form.Label id="email">
                      Email
                    </Form.Label>
                    <Form.Text
                      id="email"
                      name="email"
                      type="text"
                      defaultValue={props.location.state.userEmail}
                      readOnly
                    />
                  </Form.Group>
                </Row>
                <Row className='why-btn'>
                  <Form.Group className="position-relative mb-3">
                    <Form.Label id="password" >
                      Set a Mobile Number
                    </Form.Label>
                    <Form.Text
                      id="mobile"
                      name="mobile"
                      maxLength="10"
                      placeholder="Enter your 10 digit mobile number"
                      ref={register({
                        required: "Mobile can not be empty",
                        validate: { regex: mobileNumberRegex },
                      })}
                      className="pt-2 pl-5"
                      startAdornment={{ customAdornment: "+91", containerClassName: 'border-right oui-caption co-text-grey40 adornment-mobile' }}
                    />
                    <ErrorMessage errors={errors} name="mobile">
                      {({ message }) => (
                        <Form.Message
                          type="error"
                        >
                          {message}
                        </Form.Message>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Row>
                <Row className="justify-content-end">
                  <Form.Button
                    type="submit"
                    className="w-100 mt-4 font-weight-bold rounded-btn"
                  >
                    Proceed
                  </Form.Button>
                </Row>
                <Row className='pt-2'>
                  <Form.Group className="position-relative d-flex mb-3">
                    <Form.Label id="tnc" className='pt-3 px-3'>
                      By signing up, you agree to our 
                      {" "}
                      <a href={`${process.env.PAYU_WEBSITE_HOST}/tnc`} className="highlight" target="_blank">Terms & Conditions</a>
                      {" "}
                      and
                      {" "}
                      <a href={`${process.env.PAYU_WEBSITE_HOST}/privacy-policy`} className="highlight" target="_blank">Privacy Policy</a>
                    </Form.Label>
                  </Form.Group>
                </Row>
              </form>
          </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};


const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const mapStateToProps = (state) => {
  return {
  };
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});


const Responsive = withSizes(mapSizesToProps)(MobileSet);
export default connect(mapStateToProps, mapDispatchToProps)(Responsive);